"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescribeColumn = void 0;
const react_1 = __importDefault(require("react"));
const atoms_1 = require("../atoms");
const styled_components_1 = __importDefault(require("styled-components"));
const Styled = styled_components_1.default.section `
    .describe-link {
        padding-top: 16px;
        .navlink {
            display: flex;
            align-items: center;
            align-content: center;
            justify-content: flex-start;
            padding-left: 0;

            .h4 {
                color: ${p => p.theme.palette.text.primary};
                font-family: ${(p) => p.theme.fonts.heading3 || p.theme.fonts.default};
            }
            &:hover {
                .arrow-wrap {
                    transform: translate3d(0, 0, 0) translateX(1px);
                }
            }
        }
    }
`;
const DescribeColumn = ({ title, description, link = {}, locale }) => {
    const validLink = Boolean(link && link.title && (link.href || link.onClick));
    return (react_1.default.createElement(Styled, { className: "describe" },
        react_1.default.createElement(atoms_1.Heading2, null, title),
        react_1.default.createElement(atoms_1.Paragraph, null, description),
        validLink &&
            react_1.default.createElement("div", { className: "describe-link" },
                react_1.default.createElement(atoms_1.NavLink, { link: link, locale: locale },
                    react_1.default.createElement(atoms_1.Heading4, null, link.title),
                    react_1.default.createElement(atoms_1.ArrowIcon, { face: "right", relative: true })))));
};
exports.DescribeColumn = DescribeColumn;
//# sourceMappingURL=DescribeColumn.js.map